const ACTION_TYPES = {
    UPLOAD_RESOURCES: "uploadResources",
    UPLOAD_LOGO: "uploadLogo",
    DELETE_LOGO: "deleteLogo",
    UPLOAD_FAVICON: "uploadFavicon",
    DELETE_FAVICON: "deleteFavicon",
    UPLOAD_CUSTOMER_CONFIG: "uploadCustomerConfig",
    DEPLOYMENT_IN_PROGRESS: "deploymentInProgress",
    DOWNLOAD_IN_PROGRESS: "downloadInProgress",
    BUILD_ONPREM_IN_PROGRESS: "buildOnPremInProgress",
    DOWNLOAD_ONPREM_BUILD_IN_PROGRESS: "downloadOnPremBuildInProgress",
    AVAILABLE: ""
};

export default ACTION_TYPES;
